import ChatBoxBlock from './ChatBoxBlock';

export default ChatBoxBlock;
